export default {"src":"/_next/static/media/Anz.158dc494.svg","height":31,"width":96};